export enum ScenarioItemType {
  FACEBOOK,
  TWITTER,
  TEXT,
  AUDIO,
  VIDEO,
  QUESTION,
  DELETED,
  IMAGE,
  PDF,
  GOOGLE_MAP,
  HYPERLINK,
  TEXT_MESSAGE,
  GOOGLE_EARTH,
  OPEN_FORUM,
  MEETING,
}

export enum ScenarioItemTypeNew {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  TEXT = 'text',
  AUDIO = 'audio',
  VIDEO = 'video',
  IMAGE = 'image',
  PDF = 'pdf',
  GOOGLE_MAP = 'google-map',
  HYPERLINK = 'hyperlink',
  TEXT_WITH_AUTHOR = 'text-with-author',
  GOOGLE_EARTH = 'google-earth',
  OPEN_FORUM = 'open-forum',
  QUESTION = 'question',
  MULTI_CHOICE = 'multi-choice',
  LINEAR = 'linear',
  POLL = 'poll',
  MS_TEAMS = 'ms-teams',
  CHIME = 'chime',
  ZOOM = 'zoom',
  GOOGLE_MEETS = 'google-meets',
  EMBEDDED_FACEBOOK = 'embedded-facebook',
  EMBEDDED_FLOURISH = 'embedded-flourish',
  EMBEDDED_SLIDO = 'embedded-slido',
  EMBEDDED_GOOGLE_DOCS = 'embedded-google-docs',
  EMBEDDED_GOOGLE_SHEETS = 'embedded-google-sheets',
  EMBEDDED_GOOGLE_SLIDES = 'embedded-google-slides',
  EMBEDDED_GOOGLE_FORMS = 'embedded-google-forms',
  EMBEDDED_DATAWRAPPER = 'embedded-datawrapper',
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
  BRIGHTCOVE = 'brightcove',
  EMAIL = 'email',
  RANSOMWARE_NOTE = 'ransomware-note',
  PHONE_CALL_TRANSCRIPT = 'phone-call-transcript',
  NEWS_POST = 'news-post',
  SERVICE_DESK_TICKET = 'service-desk-ticket',
  RANSOMWARE_LEAK_SITE = 'ransomware-leak-site',
  TEAM_CHAT = 'team-chat',
  WEB_POST_DATA = 'web-post',
  BRANCHING = 'branching',
}
